<template>
  <el-button
    :class="`separate ${classP}`"
    :disabled="disabled"
    :loading="loading"
    :primary="primary"
    :sutartis="sutartis"
    :small="small"
    :x-small="xSmall"
    ><v-icon small>{{ icon }}</v-icon> <span class="pl-2"><slot /></span
  ></el-button>
</template>

<script>
export default {
  name: 'ElButtonSeparate',
  props: {
    classP: String,
    icon: String,
    disabled: Boolean,
    loading: Boolean,
    primary: Boolean,
    sutartis: Boolean,
    small: Boolean,
    xSmall: Boolean,
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
